module.exports = __webpack_public_path__ + "img/Camera&lens6.c97f37f0.png";